import { ShimmerEffect } from "../shimmer";

export const CalendarShimmer = ({ isDesktop }) => {
  return (
    <div className="flex bg-gray-200 text-xs leading-6 text-gray-700 lg:flex-auto">
      <div className="grid grid-cols-7 gap-px flex-auto bg-gray-200">
        {/* Generate 42 day cells (6 weeks * 7 days) for calendar grid */}
        {Array.from({ length: 42 }).map((_, index) => (
          <div key={index} className="bg-white px-3 py-4">
            <div className="flex flex-col space-y-1 h-full justify-between">
              {/* Day number shimmer */}
              <ShimmerEffect className="h-6 w-6 rounded-full" />

              {/* Event indicators shimmer - randomly show 0-3 events */}
              {Math.random() > 0.6 && (
                <div className="space-y-1">
                  <ShimmerEffect className="h-2 w-full" />
                  {Math.random() > 0.7 && (
                    <ShimmerEffect className="h-2 w-3/4" />
                  )}
                  {Math.random() > 0.8 && (
                    <ShimmerEffect className="h-2 w-1/2" />
                  )}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
